import './init.ts'
import '../scss/main.scss'
import Main from './main'
import { exposeShared } from './expose'
            
try {
    Main.start()
    exposeShared()
} catch (e) {
    console.error('Error starting plugin-annotations', e)
}
